import { Route, Switch, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useState } from 'react'
import { t } from 'ttag'

import { Link } from '@h2/common/components/link'
import { ListWithDetail } from '@h2/components/containers/listWithDetail'
import { api } from '@h2/api'
import { Loader } from '@h2/components/loading/loader'
import { Text } from '@h2/components/typography/text'
import { Flex } from '@h2/components/layout/flex'

import { GroupListing } from './groupListing'
import { GroupDetail } from './groupDetail'
import { GroupFilterGrid } from './components/groupFilterGrid'

import { AnimatedContainer } from '../commonComponents/animatedContainer'

const Groups = ({ routeColor }) => {
  const { groupId } = useParams()
  const [filtersSet, setFiltersSet] = useState({})
  const { data, isFetching } = useQuery([`groups`, filtersSet], () => {
    if (filtersSet?.groups && filtersSet?.groups.term.length) {
      return api.fetch(`/admin/users/groups/search`, {
        method: 'POST',
        version: 'v1',
        body: { term: filtersSet?.groups.term }
      })
    }

    return api.fetch(`/admin/users/groups/list`, {
      method: 'GET',
      version: 'v1'
    })
  })
  const filter = {
    key: 'groups',
    getData: filtersSet,
    setData: setFiltersSet
  }

  if (isFetching) {
    return <Loader />
  }

  const resultRenderer = row => (
    <Link href={`/management/groups/${row.id}`}>
      <Flex gap="2px" direction="column">
        <Text size="medium" margin="0 0 4px 0">
          {row.name}
        </Text>
        <Text size="small" margin="0">
          <Text size="small" as="span" weight="bold">{t`Created: `}</Text>{' '}
          {new Date(row.created).toLocaleDateString()}
        </Text>
        <Text size="small" margin="0">
          <Text size="small" as="span" weight="bold">{t`Members:`}</Text>{' '}
          {row.members?.length}
        </Text>
      </Flex>
    </Link>
  )
  const routes = [
    {
      path: '/management/groups',
      exact: true,
      render(props) {
        return <GroupListing {...props} results={data} />
      }
    },
    {
      path: '/management/groups/:groupId',
      render(props) {
        return (
          <ListWithDetail
            isFetching={isFetching}
            paramKey="groupId"
            results={data}
            resultRenderer={resultRenderer}>
            <GroupDetail {...props} />
          </ListWithDetail>
        )
      }
    }
  ]

  return (
    <div>
      <GroupFilterGrid routeColor={routeColor} filter={filter}></GroupFilterGrid>
      <AnimatedContainer unconstrained={!groupId}>
        <Switch>
          {routes.map((route, idx) => (
            <Route
              key={idx}
              {...route}
              render={props => {
                return route.render({ ...props })
              }}
            />
          ))}
        </Switch>
      </AnimatedContainer>
    </div>
  )
}

export { Groups }
